/** Evita envío implícito del formulario al pulsar Enter en campos de texto. */
export function blockImplicitFormSubmitOnEnter(e) {
  if (e.key !== 'Enter' || e.defaultPrevented) return;
  const tag = e.target?.tagName?.toLowerCase();
  if (tag === 'textarea') return;
  if (tag === 'button') return;
  if (tag === 'select') return;
  if (tag === 'input') {
    const type = (e.target.type || 'text').toLowerCase();
    if (type === 'submit' || type === 'button') return;
  }
  e.preventDefault();
}
